<template>
  <v-dialog
    :value="showDialog"
    width="400"
    persistent
    @input="closeDialog"
  >
    <v-card>
      <v-toolbar
        dark
        dense
        color="blue darken-1"
      >
        <v-toolbar-title>
          {{ isFind?`找回登入密碼`: '修改登入密碼' }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog"
        >
          <v-icon small>
            close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-if="isFind"
            v-model="model.cellphone"
            :rules="[
              $store.state.validationRules.required,
              $store.state.validationRules.cellphone,
            ]"
            label="手機號碼"
            type="text"
          />
          <v-text-field
            v-else
            :value="model.cellphone | hidePhone"
            :rules="[
              $store.state.validationRules.required,
            ]"
            disabled
            label="手機號碼"
            type="text"
          />
          <v-layout align-center>
            <v-flex>
              <v-text-field
                v-model="model.captcha"
                :disabled="!sentCaptch"
                :rules="[
                  $store.state.validationRules.required,
                  $store.state.validationRules.captcha,
                ]"
                :error="!!errorMessage"
                :error-messages="errorMessage"
                label="手機驗證碼"
                type="text"
              />
            </v-flex>
            <v-btn
              :disabled="captchaTimer > 0"
              :loading="sendLoading"
              color="info"
              class="mr-0"
              small
              @click="sendCaptcha"
            >
              <span v-if="captchaTimer > 0">
                {{ captchaTimer }} 重新獲取
              </span>
              <span v-else-if="sentCaptch">
                重發驗證碼
              </span>
              <span v-else>
                取得驗證碼
              </span>
            </v-btn>
          </v-layout>

          <template v-if="sentCaptch">
            <v-text-field
              v-model="model.newPassword"
              :rules="[$store.state.validationRules.required]"
              type="password"
              label="新的登入密碼"
            />
            <v-layout class="mt-2">
              <v-spacer />
              <v-btn
                :loading="loading"
                :disabled="loading"
                block
                color="info"
                @click="submit"
              >
                送出
              </v-btn>
              <v-spacer />
            </v-layout>
          </template>
        </v-form>
      </v-card-text>

      <GetCaptcha ref="GetCaptcha" />
    </v-card>
  </v-dialog>
</template>
<script>
import GetCaptcha from '@g/components/GetCaptcha'
export default {
  components: {
    GetCaptcha
  },
  props: {
    showDialog: Boolean,
    type: String,
  },
  data () {
    return {
      loading: false,
      model: {
        newPassword: '',
        captcha: '',
        cellphone: '',
      },

      captchaTimer: 0,
      sentCaptch: false,
      sendLoading: false,
      needCatptch: false, // 需要验证码
      errorMessage: '',

    }
  },
  computed: {
    user () {
      return this.$store.state.userData
    },
    isFind () {
      return this.type === 'find'
    }
  },
  watch: {
    user: {
      handler () {
        if (!this.isFind) {
          this.model.cellphone = this.user.cellphone
        }
      },
      immediate: true
    },
    'model.captcha' () {
      this.errorMessage = ''
    },
  },
  mounted () {
  },
  methods: {
    closeDialog () {
      this.$emit('update:showDialog', false)
    },
    async sendCaptcha () {
      try {
        this.sendLoading = true
        let gRecaptchaResponse
        if (this.needCatptch) {
          gRecaptchaResponse = await this.$refs.GetCaptcha.validate()
        }
        const res = await this.$store.dispatch('user/login/sendResetPasswordCaptcha', {
          cellphone: this.model.cellphone,
          gRecaptchaResponse
        })
        if (!res.data.error) {
          this.sentCaptch = true
          this.captchaTimer = 60
          const tiemr = setInterval(() => {
            this.captchaTimer--
            if (this.captchaTimer < 1) {
              clearInterval(tiemr)
              // 重置机器人验证
            }
          }, 1000)
        } else if (res.data.name === 'gRecaptchaResponseEmpty') {
          this.needCatptch = true
        }
      } finally {
        this.sendLoading = false
      }
    },
    async submit () {
      try {
        if (!this.$refs.form.validate()) return
        this.loading = true
        const res = await this.$store.dispatch('user/login/resetPassword', this.model)
        if (!res.data.error) {
          this.$snackbar('設置密碼成功')
          this.closeDialog()
          if (this.isFind) {
            // 官网独立登录页（MPA，无 vue-router）也复用本弹窗：找回密码即已登录，整页重载由页面自行回会员区
            if (this.$router) {
              this.$router.replace({ name: 'Home' })
            } else {
              window.location.reload()
            }
          }
        } else {
          this.errorMessage = res.data.message || res.data.error
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
